import script from "./report-config-form-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./report-config-form-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./report-config-form-drawer.vue?vue&type=style&index=0&id=2b6061ae&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b6061ae"]])

export default __exports__